<div class="card card-login">
  <div class="card-content">
    <div class="row">
      <div class="container-fluid">
        <div class="login-header text-center">
          <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
          <h4>Forgotten your password?</h4>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!hideForm && !questionsLoaded">
      <p *ngIf="secQuestionsSelected && !recoveryEmailSelected">
        If you have answers of security questions stored in Able+ then enter
        your username to get your personal security questions.
      </p>
      <p *ngIf="recoveryEmailSelected && !secQuestionsSelected">
        If you have a recovery email address stored in Able+ then enter it below
        to be sent your username and details to allow you to reset your
        password.
      </p>
      <br />

      <div class="radio radio-inline">
        <label>
          <input type="radio" name="optionsRadios" [checked]="secQuestionsSelected"
            (click)="onSelectSecQuestions()" />Security Questions
        </label>
      </div>
      <br />
      <div class="radio radio-inline">
        <label>
          <input type="radio" name="optionsRadios" (click)="onSelectRecEmail()" />Recovery Email
        </label>
      </div>

      <form [formGroup]="forgotPwdForm" *ngIf="this.recoveryEmailSelected && !this.secQuestionsSelected && !hideForm">
        <br>

        <div class="form-group label-floating is-empty">
          <label class="control-label">Recovery email address</label>
          <input type="email" class="form-control" formControlName='email'>
          <div class="help-block"
            *ngIf="forgotPwdForm.get('email').errors && (forgotPwdForm.get('email').dirty || forgotPwdForm.get('email').touched)">
            <span class="text-danger" [hidden]="!forgotPwdForm.get('email').errors.emailFormat">The email format is
              invalid</span>
          </div>
        </div><br>

        <button [disabled]="!forgotPwdForm.valid" (click)="forgotPwdSubmit()" class="btn btn-block btn-primary"
          [ngStyle]="{
            'background-color': this.sharedService.ButtonColor.value,
            color: this.sharedService?.TextButtonColor?.value
          }"
        >
          Reset password</button
        ><br />
      </form>

      <form [formGroup]="usernameSecQuestionForm"
        *ngIf="!this.recoveryEmailSelected && this.secQuestionsSelected && !hideForm"><br>

        <div class="form-group label-floating is-empty">
          <label class="control-label">Username</label>
          <input type="text" class="form-control" formControlName='username'>
          <div class="help-block"
            *ngIf="usernameSecQuestionForm.get('username').errors && (usernameSecQuestionForm.get('username').dirty || usernameSecQuestionForm.get('username').touched)">
            <span class="text-danger" [hidden]="!usernameSecQuestionForm.get('username').valid">Please put your
              username.</span>
          </div>
        </div><br>

        <button
          [disabled]="!this.usernameSecQuestionForm.valid"
          class="btn btn-block btn-primary"
          (click)="loadSecurityQuestionsFromIDAM()"
          [ngStyle]="{
            'background-color': this.sharedService?.ButtonColor?.value,
            color: this.sharedService?.TextButtonColor?.value
          }"
        >
          Get Security Questions</button
        ><br />
      </form>
    </ng-container>

    <ng-container *ngIf="this.questionsLoaded">
      <p class="col-md-12">Please answer the security questions.</p>

      <div class="input-group col-md-12" [formGroup]="securityQuestionForm" novalidate>
        <div formArrayName="securityQuestion">
          <div *ngFor="let security of this.secQuesToDisplay['controls']; let i = index">
            <div [formGroupName]="i">
              <div class="form-group">
                <div class="col-md-12" style="padding-bottom: 20px">
                  <div>
                    Question {{ i + 1 }}
                    <span class="badge cursor-pointer" style="background-color: white"
                      *ngIf="this.checkIfDuplicatedQuestionSelectedByIndex(i)">
                      <i class="material-icons" style="color: red; font-size: 22px; margin-top: -1px"
                        title="This question is selected. Choose another question.">
                        error</i>
                    </span>
                  </div>

                  <div *ngIf="this.securityQuestionsList.length > 1">
                    <able-dropdown [currentDropValue]="dropdownCurrentQuestion"
                      [dropdownList]="this.securityQuestionsList" (OnChange)="onSelectSecurityQuestion($event, i)"
                      [fullWidthButton]="true">
                    </able-dropdown>
                  </div>


                    <div *ngIf="this.securityQuestionsList.length ==  1">

                      <span class="number-circle pull-left"> {{i+1}}</span> {{this.securityQuestionsList[0].label}}

                    </div>
                  <div class="form-group label-floating is-empty"
                    [ngClass]="{'has-error':(security.controls['answer'].touched || security.controls['answer'].dirty) && !security.controls['answer'].valid}">
                    <label class="control-label">Answer {{ i + 1 }}</label>
                    <input class="form-control" [disabled]="this.checkIfDuplicatedQuestionSelectedByIndex(i)"
                      type="text" formControlName="answer" [popover]="popTemplateD" triggers="input:focusout"
                      placement="bottom" #pop="bs-popover"
                      (input)="this.checkAnswersLength($event.target.value, this.userdetails.security?.minSecurityAnswerCharacters)" />

                    <span class="text-danger" style="font-size: smaller"
                      *ngIf="security.controls['answer'].hasError('pattern')">
                      Only alphanumeric characters allowed.
                    </span>
                    <ng-template #popTemplateD>
                      <div class="row" style="padding-left: 10px; padding-right: 10px"
                        *ngIf="this.userdetails.security?.minSecurityAnswerCharacters">
                        <label>Answer {{ i + 1 }}</label><br />
                        <div>
                          <i *ngIf="isAnswerLengthValid" class="material-icons" style="color: green">done</i>
                          <i *ngIf="!isAnswerLengthValid" class="material-icons" style="color: lightgrey">clear</i>
                          Minimum {{userdetails.security.minSecurityAnswerCharacters}} characters
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div formGroupName="passwordGroup" [ngClass]="{'has-error': securityQuestionForm.get('passwordGroup').errors}">
          <div class="input-group"
            [ngClass]="{'has-error': (securityQuestionForm.get('passwordGroup.newPassword').touched || securityQuestionForm.get('passwordGroup.newPassword').dirty) && !securityQuestionForm.get('passwordGroup.newPassword').valid}">
            <div class="col-md-12">
              <div class="form-group label-floating is-empty"
                [ngClass]="{'has-error': (securityQuestionForm.get('passwordGroup.newPassword').touched || securityQuestionForm.get('passwordGroup.newPassword').dirty) && !securityQuestionForm.get('passwordGroup.newPassword').valid}">
                <label class="control-label">New password</label>
                <input [type]="this.passwordInput" formControlName="newPassword" class="form-control"
                  [popover]="popTemplate" triggers="input:focusout" placement="bottom" #pop="bs-popover"
                  (input)="this.checkPasswordStrength($event.target.value)" />
                <span *ngIf="this.passwordInput === 'password'" title="Show password"
                  class="input-group-addon addon-right text-gray cursor-pointer" (click)="passwordModeOn(true, true)">
                  <i class="mdi mdi-eye"></i>
                </span>
                <span *ngIf="this.passwordInput === 'text'" title="Hide password"
                  class="input-group-addon addon-right text-gray cursor-pointer" (click)="passwordModeOn(false, true)">
                  <i class="mdi mdi-eye-off"></i>
                </span>

                <ng-template #popTemplate>
                  <div class="row" style="padding-left: 10px; padding-right: 10px">
                    <label>Password policy</label><br />
                  </div>
                  <div *ngIf="!userdetails.security" class="row" style="padding-left: 10px; padding-right: 10px">
                    <label>No Password policy are loaded for this user</label><br />
                  </div>

                  <ng-container *ngIf="userdetails">
                    <div *ngIf="userdetails.security.usernameRestriction" class="row"
                      style="padding-left: 10px; padding-right: 10px">
                      <div>
                        <i *ngIf="usernameContains" class="material-icons" style="color: green">done</i>
                        <i *ngIf="!usernameContains" class="material-icons" style="color: lightgrey">clear</i>
                        Should be different from the username
                      </div>
                    </div>

                    <div
                      *ngIf="userdetails.security.usernameRestriction && userdetails.security.usernameCharacterNo > 0"
                      class="row"
                      style="padding-left: 10px; padding-right: 10px"
                    >
                      <div>
                        <i *ngIf="usernameChar" class="material-icons" style="color: green">done</i>
                        <i *ngIf="!usernameChar" class="material-icons" style="color: lightgrey">clear</i>
                        Must not contain more than {{userdetails.security.usernameCharacterNo}} characters from the
                        user's name
                      </div>
                    </div>
                    <div class="row" style="padding-left: 10px; padding-right: 10px">
                      <div>
                        <i *ngIf="this.passwordCharNumber == userdetails.security.passwordMinCharacterNo || this.passwordCharNumber > userdetails.security.passwordMinCharacterNo"
                          class="material-icons" style="color: green">done</i>
                        <i *ngIf="this.passwordCharNumber < userdetails.security.passwordMinCharacterNo" class="material-icons"
                          style="color: lightgrey">clear</i>
                        Minimum {{userdetails.security.passwordMinCharacterNo}} characters
                      </div>
                      </div>
                      <!-- new password policies -->
                      <div *ngIf="userdetails.security.passwordSpaceRestriction " class="row" style="padding-left: 10px; padding-right: 10px;">
                        <div>
                          <i *ngIf="!passwordContainsSpace" class="material-icons" style="color:  green;">done</i>
                          <i *ngIf="passwordContainsSpace" class="material-icons" style="color: lightgrey;">clear</i>
                          Must not contain spaces
                        </div>
                      </div>

                      <div class="row" *ngIf="userdetails?.security?.passwordUsersNameRestriction" style="padding-left: 10px; padding-right: 10px;">
                        <div>
                          <i *ngIf="!passwordContainsNames" class="material-icons" style="color:  green;">done</i>
                          <i *ngIf="passwordContainsNames" class="material-icons" style="color: lightgrey;">clear</i>
                          Must not contains user’s name
                        </div>
                      </div>
                      <!-- end of new password policies -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px"
                      *ngIf="userdetails.security.passwordUpperCaseRestriction">
                      <i *ngIf="upperCaseNo == userdetails.security?.passwordUpperCaseNo || upperCaseNo > userdetails.security?.passwordUpperCaseNo"
                        class="material-icons" style="color: green">done</i>
                      <i *ngIf="upperCaseNo < userdetails.security?.passwordUpperCaseNo" class="material-icons"
                        style="color: lightgrey">clear</i>
                      At least {{ userdetails.security?.passwordUpperCaseNo }} upper case letter <br />
                    </div>
                    <div class="row" *ngIf="userdetails.security.passwordLowerCaseRestriction"
                      style="padding-left: 10px; padding-right: 10px">
                      <i *ngIf="lowerCaseNo == userdetails.security?.passwordLowerCaseNo || lowerCaseNo > userdetails.security?.passwordLowerCaseNo"
                        class="material-icons" style="color: green">done</i>
                      <i *ngIf="lowerCaseNo < userdetails.security?.passwordLowerCaseNo" class="material-icons"
                        style="color: lightgrey">clear</i>
                      At least {{ userdetails.security?.passwordLowerCaseNo }} lower case letter <br />
                    </div>
                    <div *ngIf="userdetails.security.passwordNumberRestriction" class="row"
                      style="padding-left: 10px; padding-right: 10px">
                      <div *ngIf="userdetails.security?.passwordNumberNo == 1">
                        <i *ngIf="containsNo == userdetails.security?.passwordNumberNo || containsNo > userdetails.security?.passwordNumberNo"
                          class="material-icons" style="color: green">done</i>
                        <i *ngIf="containsNo < userdetails.security?.passwordNumberNo" class="material-icons"
                          style="color: lightgray">clear</i>
                        Must contain number
                      </div>
                      <div *ngIf="userdetails.security?.passwordNumberNo > 1">
                        <i *ngIf="containsNo == userdetails.security?.passwordNumberNo || containsNo > userdetails.security?.passwordNumberNo"
                          class="material-icons" style="color: green">done</i>
                        <i *ngIf="containsNo < userdetails.security?.passwordNumberNo" class="material-icons"
                          style="color: lightgray">clear</i>
                        Must contain at least {{ userdetails.security?.passwordNumberNo }} numbers
                      </div>
                    </div>
                    <div *ngIf="userdetails.security?.passwordSpaceRestriction" class="row"
                    style="padding-left: 10px; padding-right: 10px;">
                    <div>
                      <i *ngIf="!passwordContainsSpace" class="material-icons" style="color:  green;">done</i>
                      <i *ngIf="passwordContainsSpace" class="material-icons" style="color: lightgrey;">clear</i>
                      Must not contain spaces
                    </div>
                  </div>
                    <div
                      class="row"
                      style="padding-left: 10px; padding-right: 10px"
                      *ngIf="userdetails.security.passwordSpecialCharRestriction"
                    >
                      <div *ngIf="userdetails.security?.passwordSpecialCharNo == 1">
                        <i *ngIf="specialCharNo == userdetails.security?.passwordSpecialCharNo || specialCharNo > userdetails.security?.passwordSpecialCharNo"
                          class="material-icons" style="color: green">done</i>
                        <i *ngIf="specialCharNo < userdetails.security?.passwordSpecialCharNo" class="material-icons"
                          style="color: lightgray">clear</i>
                        Must contain special character
                      </div>
                      <div *ngIf="userdetails.security?.passwordSpecialCharNo > 1">
                        <i *ngIf="specialCharNo == userdetails.security?.passwordSpecialCharNo || specialCharNo > userdetails.security?.passwordSpecialCharNo"
                          class="material-icons" style="color: green">done</i>
                        <i *ngIf="specialCharNo < userdetails.security?.passwordSpecialCharNo" class="material-icons"
                          style="color: lightgray">clear</i>
                        Must contain at least {{userdetails.security?.passwordSpecialCharNo}} special character
                      </div>
                    </div>
                    <div
                      class="row"
                      style="padding-left: 10px; padding-right: 10px"
                      *ngIf="userdetails.security?.customRules?.length > 0"
                    >
                      <div>
                        <i *ngIf="customRulesValidation == true" class="material-icons" style="color: green">done</i>
                        <i *ngIf="customRulesValidation == false" class="material-icons"
                          style="color: lightgray">clear</i>
                        Must match regular expression of custom rules
                      </div>
                    </div>
                  </ng-container>
                </ng-template>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group label-floating is-empty"
                [ngClass]="{'has-error': (securityQuestionForm.get('passwordGroup.confirmNewPassword').touched || securityQuestionForm.get('passwordGroup.confirmNewPassword').dirty) && !securityQuestionForm.get('passwordGroup.confirmNewPassword').valid}">
                <label class="control-label">Confirm new password</label>
                <input [type]="this.confirmPasswordInput" formControlName="confirmNewPassword" class="form-control" />
                <span *ngIf="this.confirmPasswordInput === 'password'" title="Show password"
                  class="input-group-addon addon-right text-gray cursor-pointer" (click)="passwordModeOn(true, false)">
                  <i class="mdi mdi-eye"></i>
                </span>
                <span *ngIf="this.confirmPasswordInput === 'text'" title="Hide password"
                  class="input-group-addon addon-right text-gray cursor-pointer" (click)="passwordModeOn(false, false)">
                  <i class="mdi mdi-eye-off"></i>
                </span>
                <span class="help-block pull-left"
                  *ngIf="(securityQuestionForm.get('passwordGroup.confirmNewPassword').touched || securityQuestionForm.get('passwordGroup.confirmNewPassword').dirty) && (securityQuestionForm.get('passwordGroup.confirmNewPassword').errors ||securityQuestionForm.get('passwordGroup').errors)">
                  <span *ngIf="securityQuestionForm.get('passwordGroup.confirmNewPassword').errors?.required"
                    class="text-danger">
                    Please confirm the confirm password.
                  </span>

                  <span *ngIf="securityQuestionForm.get('passwordGroup').errors?.match" class="text-danger">
                    The confirmation does not match the password.
                  </span>
                </span>
              </div>
            </div>
          </div>
          <br />

          <button class="btn btn-block btn-primary" [disabled]="checkIfDuplicatedQuestionSelected() || !passwordValidation"
            (click)="verifyAnswersForSecurityQuestions()" [ngStyle]="{
              'background-color': this.sharedService.ButtonColor.value,
              color: this.sharedService?.TextButtonColor?.value
            }"
          >
            Verify & Update password
          </button>
        </div>
      </div>
    </ng-container>

    <div *ngIf="hideForm">
      <p>
        A confirmation link has been sent to your email address. Please follow
        the instructions in the email to reset your password.
      </p>
      <p>
        If you do not receive an email then please contact your organisation's
        Able+ administrator.
      </p>
    </div>
  </div>

  <div class="footer text-center">
    <p class="small">
      <a routerLink="/login" routerLinkActive="active">
        Sign in with a different account
      </a>
    </p>
  </div>
</div>
